// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2Av88","footer":"styles_footer__1rch9"};